

import getAcaraColors from 'styleVariables/getAcaraColors';


export const mainNavNotifications = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '2rem',
  width: '2rem',
  height: '2rem',
  float: 'left',
  background: 'transparent',
  borderRadius: '1.6rem',
  backgroundHover: '#ecf1fe'
};

export const toolIconList = (themeMode) => {
  return {
    display: 'inline-block',
    position: 'relative',
    iconSize: '2rem',
    width: '2rem',
    height: '2rem',
    margin: '1.25rem',
    float: 'right',
    background: getAcaraColors(themeMode).lightVioletSemiTransparent,
    iconStroke: getAcaraColors(themeMode).acaraViolet,
    borderRadius: '1.6rem',
    hoverIconStroke: getAcaraColors(themeMode).acaraViolet,
    backgroundHover: '#ffffff'
  };

};

export const smallSettingsIcon = (themeMode) => {
  return {
    display: 'inline-block',
    position: 'relative',
    iconSize: '1.2rem',
    width: '2rem',
    height: '2rem',
    padding: '0.4rem',
    margin: '1.25rem',
    float: 'right',
    background: getAcaraColors(themeMode).lightVioletSemiTransparent,
    iconStroke: getAcaraColors(themeMode).acaraViolet,
    borderRadius: '1.6rem',
    hoverIconStroke: getAcaraColors(themeMode).acaraViolet,
    backgroundHover: '#ffffff'
  };
};

export const toolbarEditorTopNavIcon = (themeMode) => {
  return {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    iconSize: '1.6rem',
    width: 'fit-content',
    height: '4.5rem',
    padding: '1rem',
    margin: '0',
    float: 'left',
    background: '#ffffff',
    iconStroke: getAcaraColors(themeMode).acaraViolet,
    borderRadius: '.6rem',
    hoverIconStroke: getAcaraColors(themeMode).acaraViolet,
  };
};

export const toolbarEditorViewPortIcon = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '1.6rem',
  width: 'fit-content',
  height: '4.5rem',
  padding: '1.45rem 1rem',
  margin: '0',
  float: 'left',
  background: 'transparent',
  iconStroke: '#626a92',
  borderRadius: '1.6rem'
};

export const toolbarEditorViewPortIconActive = (themeMode) => {
  return {
    display: 'inline-block',
    position: 'relative',
    iconSize: '1.6rem',
    width: 'fit-content',
    height: '4.5rem',
    padding: '1.45rem',
    margin: '0',
    float: 'left',
    background: '#333951',
    iconStroke: '#ffffff',
    borderRadius: '1.6rem',
    hoverIconStroke: getAcaraColors(themeMode).acaraViolet,
    backgroundHover: '#ffffff'
  };
};


export const endUserGoBack = (themeMode) => {
  return {
    display: 'inline-block',
    position: 'relative',
    width: '4rem',
    height: '4rem',
    iconSize: '1.2rem',
    padding: '1.4rem',
    margin: '0',
    background: 'rgba(72, 53, 198, 1)19',
    iconStroke: getAcaraColors(themeMode).acaraViolet,
    borderRadius: '2rem',
    transform: 'rotate(180deg)'
  };
};

export const listHeaderControls = `
  width: 4.5rem;
  height: 4.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: #9058FF1A
  }
`;

export const listsIcon = (themeMode) => {
 return {
  display: 'inline-block',
  position: 'relative',
  iconSize: '1.2rem',
  padding: '1rem',
  margin: '0',
  float: 'right',
  background: getAcaraColors(themeMode).lightVioletSemiTransparent,
  borderRadius: '0.6rem',
  iconStroke: getAcaraColors(themeMode).acaraViolet,
  hoverIconStroke: getAcaraColors(themeMode).acaraViolet,
  backgroundHover: '#ffffff'
}
};

export const listAddOrRemove = {
  ...listsIcon(),
  iconStroke: '#FF6256',
  hoverIconStroke: '#ffffff',
  border: '1px solid #FF6256',
  background: '#ffffff',
  backgroundHover: '#FF6256',
  height: '2rem',
  width: '2rem'
};

export const paginationArrows = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '1.2rem',
  margin: '0',
  iconStroke: '#7d7d8f',
  hoverIconStroke: '#7d7d8f'
};

export const smallArrow = (themeMode) => {
  return {
    display: 'inline-block',
    position: 'relative',
    iconSize: '1.2rem',
    width: '2rem',
    height: '2rem',
    margin: '0',
    iconStroke: getAcaraColors(themeMode).acaraViolet,
    hoverIconStroke: getAcaraColors(themeMode).acaraViolet,
  }
};

export const sortIcon = (themeMode) => { 
  return `
  background: #ffffff;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: baseline;

  &:hover {
    background: ${getAcaraColors(themeMode).lightVioletSemiTransparent};
  }
`;
};

export const sortIconActive = (themeMode) => {
  return `
    background: ${getAcaraColors(themeMode).lightVioletSemiTransparent};
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    align-items: baseline;

    &:hover {
      background: ${getAcaraColors(themeMode).lightVioletSemiTransparentActive};
    }
  `
};



export const integrationIcon = `
  background: #FFFFFF;

  width: 6rem;
  height: 6rem;
  padding: 1rem;
  margin: 0;
  cursor: default;
  border-radius: 1rem;
  box-shadow: 0 0 4px 0 rgb(145 150 178 / 20%);

  & svg {
    max-width: 4rem !important;
    max-height: 4rem !important;
  }
`;

export const editorBackButtonIcon = (themeMode) => {
  return {
    iconStroke: getAcaraColors(themeMode).acaraViolet,
    transform: 'rotate(180deg)',
    float: 'left'
  };
};

export const iconHideStyles = `
  fill: rgb(198, 202, 219);
`;

export const iconShowStyles = `
  fill: rgba(111, 88, 255, 1);
`;


export const stylingButtonIcon = {
  hoverIconStroke: 'rgba(111, 88, 255, 1)',
  iconFill: 'none',
}

export const stylingButtonMonospace = {
  hoverIconStroke: 'none',
  hoverIconFill: 'rgba(111, 88, 255, 1)',
}